import React from "react";
import { FaIcon } from "../../../lib/FaIcon";
import { useScrollPosition } from "react-use-scroll-position";
import { DelayedRender } from "./DelayedRender";

export const ScrollToTopButton = () => {
  useScrollPosition();
  const isVisible = window.pageYOffset > 0;

  if (!isVisible) {
    return null;
  }

  return (
    <DelayedRender delay={1000}>
      <ScrollUpButton />
    </DelayedRender>
  );
};

export function ScrollUpButton() {
  return (
    <div className="position-fixed" style={{ right: 10, bottom: 10 }}>
      <FaIcon icon="fas fa-chevron-circle-up fa-3x text-gray hover-primary" onClick={() => window.scrollTo(0, 0)} />
    </div>
  );
}
